import { IconColor } from '~/components/workspace/icon-metadata'

export function resolveIconColor(color?: string | null) {
  return color ? IconColor[color as keyof typeof IconColor] : IconColor.gray
}
